import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { FunctionComponent, useContext, useEffect } from "react";
import propTypes from "prop-types";
import TreeView, { ITreeViewLoaderProps, ITreeViewState, TreeViewCommand, TreeViewContext } from "../../treeView/TreeView";
import { useState } from "react";
import ProductsTreeViewLoader from "../../treeView/loaders/ProductsTreeViewLoader";
import { FiFolder, FiFolderPlus } from "react-icons/fi";
import { Product, UpsellPackage, UpsellPackagedProduct } from "../../../logic/api";
import TextInputField from "../../editable/EditableField/fields/TextInputField";
import flex from "../../../styles/flex";
import UpsellSelector from "../../upsells/upsell_selector/UpsellSelector";
import { SessionContext } from "../../../utility/useSession";
import { useTranslation } from "react-i18next";
const ProductPickerDialog: React.FunctionComponent<{
    title?: string;
    show: boolean;
    bookingId?: number;
    treeViewLoader?: {
        constructor: FunctionComponent<ITreeViewLoaderProps>,
        flags?: Record<string, unknown>,
    }
    onClose: (product: Product | null) => void;
    onUpsellSelect?: (pkg: UpsellPackage, product: UpsellPackagedProduct) => void,
}> = (props) => {
    const [state, setState] = useState<ITreeViewState>({
        treeRootId: 0,
        selectedRecord: null,
        flags: props.treeViewLoader?.flags ?? {}
    });

    const session = useContext(SessionContext);
    const { t } = useTranslation();
    const [filter, setFilter] = useState("");
    const [cancel, setCancel] = useState<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (props.show == true) {
            setState({ ...state, selectedRecord: null });
        }
    }, [props.show]);

    const showUpsells = props.bookingId != null && props.onUpsellSelect != null && session.current.site?.preferences.booking_upsells_enabled == true;


    return <Dialog open={props.show} maxWidth="md" fullWidth={true}>
        <DialogTitle>{props.title == null ? t("pickers.selectProduct") : props.title}</DialogTitle>
        <DialogContent style={{ height: 40, minHeight: 40 }}>
            <TextInputField maxWidth={"unset"} label={t("pickers.searchProducts")} value={filter} onChange={(value) => {
                setFilter(value);
                if (cancel != null) {
                    clearTimeout(cancel);
                }
                setCancel(setTimeout(() => {
                    setState({
                        ...state,
                        flags: {
                            ...state.flags,
                            filter: value
                        }
                    });
                }, 1000));
            }}></TextInputField>
        </DialogContent>
        <DialogContent>

            <div style={flex.flexRows}>
                <div style={flex.flexFill}>
                    <TreeViewContext.Provider value={{
                        state,
                        setState: (updatedState) => {
                            if (updatedState.selectedRecord) {
                                const product = updatedState.selectedRecord as Product;
                                if (product.hasChildren == false) {
                                    props.onClose(product);
                                } else {
                                    setState({
                                        ...state, command: {
                                            command: TreeViewCommand.expanded,
                                            payLoad: updatedState.selectedRecord,
                                            targetId: updatedState.selectedRecord.id
                                        }
                                    });
                                }
                            }
                            setState(updatedState);
                        },
                        treeViewLoader: props.treeViewLoader?.constructor ?? ProductsTreeViewLoader,
                        getNodeDesign: (record) => {
                            const product = record as Product;
                            if (product.hasChildren == false) {
                                return {
                                    colour: "green",
                                    icon: FiFolderPlus,
                                };
                            } else {
                                return {
                                    colour: "grey",
                                    icon: FiFolder
                                };
                            }
                        },

                    }}>
                        <TreeView></TreeView>
                    </TreeViewContext.Provider>

                </div>
                {(showUpsells == true && props.bookingId != null) && (
                    <div style={flex.flexFill}>
                        <UpsellSelector onSelect={(pkg, product) => {
                            if (props.onUpsellSelect != null) {
                                props.onUpsellSelect(pkg, product);
                            }
                        }} bookingId={props.bookingId} />
                    </div>
                )}

            </div>



        </DialogContent>
        <DialogActions>
            <Button onClick={() => {
                props.onClose(null);
            }}>
                {t("general.cancel")}
            </Button>
        </DialogActions>
    </Dialog>;
};

ProductPickerDialog.propTypes = {
    title: propTypes.string,
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired,
    bookingId: propTypes.any,
    onUpsellSelect: propTypes.func,
}

export default ProductPickerDialog;
